import { CommonModule } from '@angular/common';
import {
    Component,
    computed,
    inject,
    ChangeDetectionStrategy,
} from '@angular/core';
import { ToastService } from '../../core/services/toast/toast.service';

/**
 * Composant d'affichage des notifications toast.
 *
 * Utilise directement le signal du ToastService pour une reactivite automatique.
 */
@Component({
    selector: 'app-toast',
    imports: [CommonModule],
    templateUrl: './toast.component.html',
    styleUrl: './toast.component.css',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToastComponent {
    private readonly toastService = inject(ToastService);

    /** Signal du toast actuel (lecture directe depuis le service) */
    readonly toast = this.toastService.currentToast;

    /** Classe CSS calculee selon le type de toast */
    readonly typeClass = computed(() => {
        const t = this.toast();
        return t ? `toast--${t.type}` : '';
    });

    onCloseClick(): void {
        this.toastService.hide();
    }
}
